<template>
  <section id="store_container">
    <Styles>
      <div class="columns">
        <div class="column">
          <CompanySelector v-model="company" />
        </div>
        <div class="column">
          <b-field label="Id Mercado Pago">
            <b-input
              placeholder="Id Mercado Pago"
              type="text"
              v-model="idMercadoPago"
              name="idMercadoPago"
              disabled
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Nombre de la tienda">
            <b-input
              type="text"
              v-model="name"
              placeholder="Nombre de la tienda"
              name="name"
              v-validate="'required'"
            ></b-input>
          </b-field>
          <span class="show-error">{{ errors.first("name") }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">External Id</label>
            <div class="control is-clearfix">
              <input
                type="text"
                placeholder="Ingrese el External Id"
                autocomplete="off"
                name="externalId"
                v-model="externalId"
                class="input"
                maxlength="20"
                :disabled="!externalIdChecked"
              />
            </div>
          </div>
          <span class="show-error">{{ errors.first("externalId") }}</span>
        </div>
        <div class="column">
          <b-field label="Nombre de la calle">
            <b-input
              placeholder="Ingrese el nombre calle"
              type="text"
              v-model="streetName"
              v-validate="'required'"
              name="streetName"
            ></b-input>
          </b-field>
          <span class="show-error">{{ errors.first("externalId") }}</span>
        </div>
        <div class="column">
          <b-field label="Número de la calle">
            <b-input
              placeholder="Ingrese el número de la calle"
              type="text"
              v-model="streetNumber"
              name="streetNumber"
              v-validate="'required'"
            ></b-input>
          </b-field>
          <span class="show-error">{{ errors.first("externalId") }}</span>
        </div>
      </div>
      <div class="columns mb-1">
        <div class="column">
          <b-field label="Indicaciones">
            <b-input
              placeholder="Ingrese las indicaciones"
              type="text"
              v-model="indications"
              name="indications"
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Horario">
            <b-select
              placeholder="Seleccione un Horario..."
              expanded
              v-model="schedule"
              v-validate="'required'"
              name="schedule"
            >
              <option
                v-for="option in schedules"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
          <span class="show-error">{{ errors.first("schedule") }}</span>
        </div>
        <div class="column"></div>
      </div>
      <div class="buttons button-group">
        <b-button @click="save()" type="is-info" v-if="selected == null">
          Guardar
        </b-button>
        <b-button @click="save()" type="is-info" v-if="selected != null">
          Editar
        </b-button>
        <b-button
          v-if="selected != null"
          @click="openDeleteModal()"
          type="is-danger"
          icon-right="delete"
        >
          Eliminar
        </b-button>
      </div>
      <div class="columns" v-if="responseError">
        <div class="column">
          <h2 class="error-title">Salida del error:</h2>
          <code class="response-error">
            {{ responseError }}
          </code>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-table
            :data="tableData"
            :selected.sync="selected"
            focusable
            :paginated="true"
            :per-page="5"
            :bordered="true"
            :current-page.sync="currentPage"
          >
            <b-table-column field="title" label="Nombre" v-slot="props">
              {{ props.row.title }}
            </b-table-column>
            <b-table-column field="mpId" label="Id MercadoPago" v-slot="props">
              {{ props.row.mpId }}
            </b-table-column>
            <b-table-column
              field="externalId"
              label="External Id"
              v-slot="props"
            >
              {{ props.row.externalId }}
            </b-table-column>
            <b-table-column
              field="streetNumber"
              label="Número de la Calle"
              v-slot="props"
            >
              {{ props.row.streetNumber }}
            </b-table-column>
            <b-table-column
              field="streetName"
              label="Nombre de la Calle"
              v-slot="props"
            >
              {{ props.row.streetName }}
            </b-table-column>
            <template #bottom-left> </template>
            <template #empty>
              <div class="has-text-centered">Sin registros</div>
            </template>
          </b-table>
        </div>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </Styles>
  </section>
</template>

<script>
import { ROUTES } from "../../global/api_routes";
import CompanySelector from "../../components/Shared/CompanySelector";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { confirmation } from "../../global/utils";
import { configToast, TOAST_TYPES } from "../../global/toast";
import Styles from "./styles";
export default {
  name: "Store",
  components: { CompanySelector, Styles },
  data: () => ({
    id: null,
    company: null,
    idMercadoPago: null,
    name: null,
    externalId: null,
    externalIdChecked: false,
    indications: null,
    streetNumber: null,
    streetName: null,
    schedule: null,
    selected: null,
    isLoading: false,
    currentPage: 1,
    schedules: [],
    tableData: [],
    companies: [],
    responseError: null,
  }),
  mounted() {},
  watch: {
    async company() {
      if (!this.company) {
        this.selected = null;
        this.company = null;
        this.schedule = null;
        this.schedules = [];
        return;
      }
      this.isLoading = true;
      const schedules = await this.getSchedules();
      const listStores = await this.listStores();
      const external = await this.getExternalId(this.company);
      this.externalId = external.data.info;
      this.externalIdChecked = true;
      this.schedules = schedules.data.code > 0 ? schedules.data.info : [];
      this.tableData = listStores.data.code > 0 ? listStores.data.info : [];
      this.isLoading = false;
    },
    selected() {
      if (this.selected != null) {
        this.fillData(this.selected);
      }
    },
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#store_container");
      return instance.open(message, type);
    },
    openDeleteModal() {
      confirmation(this, `¿Desea eliminar la tienda?`).then((result) => {
        if (!result) {
          return;
        }
        this.deleteStore();
      });
    },
    deleteStore() {
      this.$http
        .delete(ROUTES.DASHBOARD.MERCADO_PAGO.DELETE, {
          data: {
            storeId: this.id,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.cleanForm();
            this.getStores();
          }
        });
    },
    save() {
      this.responseError = null;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.getS;
          return;
        }
        if (
          this.selected != null &&
          this.selected.externalId == this.externalId
        ) {
          this.toast("Debe modificar el external id", TOAST_TYPES.ERROR);
        }
        if (this.selected != null && this.selected.title == this.name) {
          this.toast("Debe modificar el nombre", TOAST_TYPES.ERROR);
          return;
        }
        const send = {
          code: this.id,
          title: this.name,
          company: {
            code: this.company,
          },
          externalId: this.externalId.trim(),
          reference: this.indications,
          streetNumber: this.streetNumber,
          streetName: this.streetName,
          mpId: this.idMercadoPago,
          schedule: {
            code: this.schedule,
          },
        };
        if (send.code == null) {
          delete send.code;
        }
        if (send.mpId == null) {
          delete send.mpId;
        }
        this.isLoading = true;
        const options = {
          method: this.selected ? "PUT" : "POST",
          data: send,
          url: this.selected
            ? ROUTES.DASHBOARD.MERCADO_PAGO.UPDATE
            : ROUTES.DASHBOARD.MERCADO_PAGO.SAVE,
        };
        this.$http(options)
          .then(({ data }) => {
            if (data.code > 0) {
              this.isLoading = false;
              this.toast(data.message, TOAST_TYPES.SUCCESS);
              this.getStores();
              this.cleanForm();
              return;
            }
            this.isLoading = false;
            this.responseError = data.info;
            this.toast(data.message, TOAST_TYPES.ERROR);
          })
          .catch(({ response }) => {
            this.isLoading = false;
            console.log(response);
            this.toast(response.data.message, TOAST_TYPES.ERROR);
          });
      });
    },
    async getStores() {
      this.isLoading = true;
      const listStores = await this.listStores();
      this.tableData = listStores.data.code > 0 ? listStores.data.info : [];
      this.isLoading = false;
    },
    cleanForm() {
      this.id = null;
      this.externalId = null;
      this.indications = null;
      this.streetName = null;
      this.streetNumber = null;
      this.schedule = null;
      this.isLoading = false;
      this.idMercadoPago = null;
      this.name = null;
      this.selected = null;
      this.tableData = [];
    },
    fillData(selected) {
      this.id = selected.code;
      this.company = selected.company.code;
      this.externalId = selected.externalId;
      this.indications = selected.reference;
      this.streetName = selected.streetName;
      this.streetNumber = selected.streetNumber;
      this.schedule = selected.schedule.code;
      this.name = selected.title;
      this.idMercadoPago = selected.mpId;
      this.isLoading = false;
    },
    listStores() {
      return this.$http.get(ROUTES.DASHBOARD.MERCADO_PAGO.LIST, {
        params: {
          companyId: this.company,
        },
      });
    },
    getSchedules() {
      return this.$http.get(ROUTES.DASHBOARD.SCHEDULES.GET_MP_SCHEDULES, {
        params: {
          companyId: this.company,
        },
      });
    },
    getExternalId(companyId) {
      return this.$http.get(ROUTES.DASHBOARD.MERCADO_PAGO.GET_EXTERNAL_ID, {
        params: {
          companyId,
          storeId: 0,
        },
      });
    },
  },
};
</script>
